// Auto-generated skeleton for Person

import { User } from "./User";
import { Address } from "./Address";

export const Person: Api.Person = {
  id: 0,
  hp_id: null,
  salutation: null,
  title: null,
  firstname: null,
  lastname: '',
  address_id: 0,
  user_id: 0,
  letter_salutation: null,
  user: User,
  update_request: null,
  address: Address,
  phonenumbers: [],
  emails: null,
  permissions: [],
  contacts: [],
  contacts_count: 0,
  created: null,
  updated: null,
};

